import { OrderOperationEntity } from 'api/types/entity';
import { Typography } from 'libs/ui';

export const renderExecutionPlace = (item: OrderOperationEntity) =>
  item.executionPlace?.name ? (
    <Typography maxLine={2} title={item.executionPlace.name}>
      {item.executionPlace.name}
    </Typography>
  ) : null;
